import React from 'react';
import { FiBriefcase, FiLayout, FiTrendingUp, FiUser } from 'react-icons/fi';
import { Footer } from '../components/layout/Footer';
import { Header } from '../components/layout/Header';
import { LeadershipSection } from '../components/sections/LeadershipSection';
import { SEOHead } from '../components/SEOHead';

export const LeadershipPage: React.FC = () => {
  return (
    <div className="App font-arabic">
      <SEOHead 
        title="قيادة ضوء الخريج - فريق من الخبراء في التقنية والتعليم"
        description="تعرف على فريق قيادة ضوء الخريج: فهد الخريج الرئيس التنفيذي وسارة الخريج الرئيسة التقنية، بالإضافة إلى مجلس المستشارين المتخصصين في التوجيه المهني."
        keywords="فهد الخريج, سارة الخريج, فريق ضوء الخريج, قيادة تقنية, خبراء التعليم, مستشارين مهنيين, ريادة الأعمال السعودية"
        canonical="https://about.alkhreej.com/leadership"
        pageType="profile"
      />
      
      {/* Fixed Header */}
      <Header />
      
      {/* Main Content */}
      <main className="relative pt-20">
        {/* Leadership Section */}
        <LeadershipSection showFullTeam={true} />
        
        {/* Counselors Board Section */}
        <section className="py-20 bg-white">
          <div className="section-container">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-government-navy mb-4 font-heading">
                مجلس المستشارين
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                نخبة من الخبراء والمختصين في مجالات متنوعة يقدمون الدعم والإرشاد لضمان جودة خدماتنا
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Career Guidance Experts */}
              <div className="card-government text-right">
                <div className="w-16 h-16 bg-brand-primary bg-opacity-10 rounded-xl flex items-center justify-center text-brand-primary mb-4 mx-right">
                  <FiBriefcase size={28} />
                </div>
                <h3 className="font-bold text-government-navy mb-2">مستشارين مهنيين</h3>
                <p className="text-brand-primary text-sm mb-3">التوجيه المهني</p>
                <p className="text-gray-600 text-xs">
                  خبراء في التوجيه المهني وتطوير المسارات الوظيفية
                </p>
              </div>

              {/* Education Experts */}
              <div className="card-government text-right">
                <div className="w-16 h-16 bg-brand-primary bg-opacity-10 rounded-xl flex items-center justify-center text-brand-primary mb-4 mx-right">
                  <FiTrendingUp size={28} />
                </div>
                <h3 className="font-bold text-government-navy mb-2">خبراء تعليميين</h3>
                <p className="text-brand-primary text-sm mb-3">التعليم والأكاديميا</p>
                <p className="text-gray-600 text-xs">
                  متخصصين في التعليم العالي ومناهج التطوير الأكاديمي
                </p>
              </div>

              {/* Psychometric Tests Experts */}
              <div className="card-government text-right">
                <div className="w-16 h-16 bg-brand-primary bg-opacity-10 rounded-xl flex items-center justify-center text-brand-primary mb-4 mx-right">
                  <FiUser size={28} />
                </div>
                <h3 className="font-bold text-government-navy mb-2">مختصين نفسيين</h3>
                <p className="text-brand-primary text-sm mb-3">الاختبارات النفسية</p>
                <p className="text-gray-600 text-xs">
                  خبراء في الاختبارات النفسية وتحليل الشخصية المهنية
                </p>
              </div>

              {/* UX Experts */}
              <div className="card-government text-right">
                <div className="w-16 h-16 bg-brand-primary bg-opacity-10 rounded-xl flex items-center justify-center text-brand-primary mb-4 mx-right">
                  <FiLayout size={28} />
                </div>
                <h3 className="font-bold text-government-navy mb-2">مصمموا التجربة</h3>
                <p className="text-brand-primary text-sm mb-3">تجربة المستخدم</p>
                <p className="text-gray-600 text-xs">
                  متخصصين في تصميم تجربة المستخدم والفهم العميق لاحتياج الطالب
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};